import useVideoCallCreate from "./Create";

const useVideoCall = () => {
  return {
    useVideoCallCreate
  };
};

export default useVideoCall;
